"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Command = _react2["default"].createClass({
	displayName: "Command",
	render: function render() {
		return _react2["default"].createElement(
			"p",
			{ className: "buttons", style: { textAlign: "left", padding: 10, position: "absolute" } },
			this.props.children
		);
	}
});

exports["default"] = Command;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/command.jsx
 ** module id = 624
 ** module chunks = 0
 **/